import Routes from '../helpers/Routes';
import {
  IAiOnboardingPharmacistLicenseVerificationResult,
  IUploadAiOnboardingDocumentParams,
  IVerifyAiOnboardingPharmacistLicenseParams,
} from '../models/AiOnboardingModels';
import httpClient from './httpClient';

const {
  general: { fileupload, signupCertificates, signupResumes },
} = Routes;

// Existing signup resume/certificate endpoints must accept the `file`
// field and behave idempotently when an upload succeeds before final profile
// submission.
// Confirm the parameterless policy document endpoints and { content: null }
// fallback contract before backend integration.
class AiOnboardingController {
  private readonly uploadBasePath: string;

  constructor() {
    this.uploadBasePath = fileupload;
  }

  getWorkEthicsDocument = () => httpClient.get(Routes.user.workEthicsDocument);

  getOperationalBriefingDocument = () =>
    httpClient.get(Routes.user.operationalBriefingDocument);

  uploadDocument = ({
    signupRequestId,
    documentType,
    form,
  }: IUploadAiOnboardingDocumentParams) => {
    const uploadPath = {
      resume: signupResumes,
      diplomaCertificate: signupCertificates,
    }[documentType];

    return httpClient.post(
      `${this.uploadBasePath}${uploadPath}?signupRequestId=${encodeURIComponent(
        signupRequestId,
      )}`,
      form,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        transformRequest: (requestForm) => requestForm,
      },
    );
  };

  verifyPharmacistLicense = (
    params: IVerifyAiOnboardingPharmacistLicenseParams,
  ) =>
    httpClient.post<IAiOnboardingPharmacistLicenseVerificationResult>(
      `${Routes.general.anonymous}${Routes.pharmacist.verifyLicense}`,
      params,
    );
}

export default new AiOnboardingController();
